import React from "react";
import { SectionHeader } from "@/shell/components/SectionHeader";
import { CustomerFrequencyTier } from "@/features/orders-analytics/types/orders-analytics.types";
import { formatters } from "@/features/orders-analytics/utils/formatters";

type Props = {
    tiers: CustomerFrequencyTier[];
};

const ShareBar: React.FC<{ value: number; color: string }> = ({ value, color }) => (
    <div className="ci-bar">
        <div className="ci-bar__track">
            <div
                className="ci-bar__fill"
                style={{ width: `${Math.min(100, value)}%`, ["--ci-bar-color" as string]: color }}
            />
        </div>
        <span className="ci-bar__value">{formatters.formatPercentage(value)}</span>
    </div>
);

export const FrequencyTiersSection: React.FC<Props> = ({ tiers }) => (
    <section className="section">
        <SectionHeader
            title="Loyalty by order frequency"
            count={tiers.length}
            meta="accounts grouped by lifetime order count"
        />
        <div className="card ci-table-card">
            <div className="ci-scroll">
                <table className="ci-tbl">
                    <thead>
                        <tr>
                            <th scope="col">Orders</th>
                            <th scope="col" className="num">Accounts</th>
                            <th scope="col">% of accounts</th>
                            <th scope="col" className="num">Orders</th>
                            <th scope="col" className="num">Revenue</th>
                            <th scope="col">% of revenue</th>
                            <th scope="col" className="num">Rev / order</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tiers.map((tier) => (
                            <tr key={tier.label}>
                                <td className="num" style={{ fontWeight: 600 }}>{tier.label}</td>
                                <td className="num">{formatters.formatNumber(tier.accounts)}</td>
                                <td>
                                    <ShareBar value={tier.accountShare} color="var(--vb-neutral-400)" />
                                </td>
                                <td className="num">{formatters.formatNumber(tier.orders)}</td>
                                <td className="num">{formatters.formatCurrency(tier.revenue)}</td>
                                <td>
                                    <ShareBar value={tier.revenueShare} color="var(--vb-primary-500)" />
                                </td>
                                <td className="num">{formatters.formatCurrency(tier.revenuePerOrder)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </section>
);
